import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import * as _moment from 'moment';
import { Reg } from 'src/app/shared/reg.model';
import { RegService } from 'src/app/shared/Reg.Service';
import { Resp } from 'src/app/shared/resp.model';
import { Router } from '@angular/router';
import { AppInsightsService } from 'src/app/shared/AppInsights.Service';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss'],
})
export class StepOneComponent implements OnInit {
  @Output() emitter: EventEmitter<string> = new EventEmitter();
  @Input() regId: string = "";
  @Input() lastName: string = "";
  public showPlaceholder: boolean;
  // userType removed: now passed from backend
  public step1 = false;
  public step2 = false;
  public isLoading = false;
  error: boolean;
  message: any;
  public resp: Resp;
  public uuid: string;
  public validate = true;
  public inValidMsg = "";
  public formErrorFields: any = {
    regId: false,
    lastName: false
  };
  
  @ViewChild("reg") reg: ElementRef;
  @ViewChild("last") last: ElementRef;

  constructor(public regService: RegService,private router: Router, private appInsightsService: AppInsightsService) {
  }

  ngOnInit() {
  	window.scroll(0, 0);
    this.generateSession();
    this.showPlaceholder = true;
    this.appInsightsService.logEvent("BAM Registration UI Step One");
  }

  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }
  toggleForm(event: FocusEvent, model) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
    this.validateForm(model);
  }
  acceptNumericOnly(event) {
    const e = event as KeyboardEvent;
    if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
          e.preventDefault();
      }
  }
  
  focusOnInput() {
  		let setError = false; 
	  	if (!!this.formErrorFields['regId']) {
	  		setError = true; 
	  		setTimeout(() => this.reg.nativeElement.focus(), 0);
	  		setTimeout(() => this.reg.nativeElement.select(), 0);
	  		window.scrollTo(0,this.reg.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
	  	} else if (!!this.formErrorFields['lastName']) {
	  		setError = true; 
	  		setTimeout(() => this.last.nativeElement.focus(), 0);
	  		setTimeout(() => this.last.nativeElement.select(), 0);
	  		window.scrollTo(0,this.last.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
	  	}
	  return setError;
  }
  
  isErrorPresent() {
  	if (!this.formErrorFields.regId && !this.formErrorFields.lastName) {
        	return false;
        } else {
        	return true;
        }    
  }
  
  validateAllFields() {
  	const fields = ["regId","lastName"];
  	let isErrPresent = false;
  	for (let j=0; j<fields.length; j++) {
  		isErrPresent = this.validateForm(fields[j]);
  		if (isErrPresent) {
  			break;
  		}
  	}
  	return isErrPresent;
  }
  
  ifAtleastOneFieldValidated(model) {
  	this.validate = !!this[model] ? false : true;
  	return this.validate;
  }
  
  validateOnKeyPress(model) {
	if (model === 'regId') {
		if(!!this.regId && (this.formErrorFields.regId || this.formErrorFields.invalidRegId)){
			this.validateForm('regId');
		}
	}
  }

  validateForm(model) {
    let error = false;
    this.validate = true;
    if (model === 'regId') {
      if (!this.regId) {
        error = true;
        this.formErrorFields['regId'] = true;
        this.formErrorFields['invalidRegId'] = false;
      } else if (!this.validateID(this.regId)) {
        error = true;
        this.formErrorFields['regId'] = false;
        this.formErrorFields['invalidRegId'] = true;
      } else {
        this.formErrorFields['regId'] = false;
        this.formErrorFields['invalidRegId'] = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
    if (model === 'lastName') {
      if (!this.lastName) {
        error = true;
        this.formErrorFields['lastName'] = true;
      } else {
        this.formErrorFields['lastName'] = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
    console.log(this.formErrorFields, error);
    if (!!this.regId && !!this.lastName && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }

  goBack() {
    window.history.go(-2);
  }

  goLogin(){
    this.router.navigate(['login']);
  }

  next() {
    if (!this.validateAllFields()) {
      const reg = new Reg();
      reg.lastName = this.lastName.trim();
      reg.StrOldUserID = this.regId;
      reg.registrationID = this.regId;
      // reg.userType removed: now passed from backend
      const bodyString = JSON.stringify(reg);
      setTimeout(() => {
        this.isLoading = true;
        this.error = false;
        this.message = "";
        this.validate = true;
      });
      this.regService.regStepOne(bodyString).subscribe(res => {
          this.resp = res;
          if (this.resp && this.resp !== undefined && Object.keys(this.resp).length > 0) {
              setTimeout(() => {
                  this.isLoading = false;
                  window.scrollTo(0, 0);
              });
            if (this.resp.status_code !== '200') {
              window.scroll(0, 0);
              this.error = true;
              this.validate = false;
              if (this.resp.message) {
                this.message = this.resp.message;
              } else {
                this.message = 'Session has expired please close browser and try again';
              }
            } else {
              this.emitter.emit('two');
            }
          }
        });
    } else {
    	this.focusOnInput();
    }
  }
  
  	validateID(str) {
		let isVal = true;
		if(str.indexOf(" ") !== -1) {
			this.inValidMsg = "Registration ID cannot contain a space";
			isVal = false;
		}
		return isVal;
	}

  generateSession() {
    let dt = new Date().getTime();
    this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
    function(c) {
      const r = (dt + Math.random() * 16) % 16 | 0; dt = Math.floor(dt / 16); return (c === 'x' ? r : (r & 0x3 | 0x8 )).toString(16);
    });
    console.log('session: ' + this.uuid);
  }
}
